webpackJsonp([228305858385457],{

/***/ 1076:
/***/ (function(module, exports) {

	module.exports = {"description":"","displayName":"Features","methods":[{"name":"routeChange","docblock":null,"modifiers":["static"],"params":[{"name":"path","type":null}],"returns":null}],"props":{"shadow":{"type":{"name":"bool"},"required":false,"description":"Establishes shadow for each card","defaultValue":{"value":"false","computed":false}},"showImage":{"type":{"name":"bool"},"required":false,"description":"Show or hide image","defaultValue":{"value":"true","computed":false}},"showTitle":{"type":{"name":"bool"},"required":false,"description":"Show or hide title","defaultValue":{"value":"true","computed":false}},"showSubtitle":{"type":{"name":"bool"},"required":false,"description":"Show or hide subtitle","defaultValue":{"value":"true","computed":false}},"showSummary":{"type":{"name":"bool"},"required":false,"description":"Show or hide summary","defaultValue":{"value":"true","computed":false}},"imageCircle":{"type":{"name":"bool"},"required":false,"description":"Establishes if image is circled","defaultValue":{"value":"false","computed":false}},"imageBorder":{"type":{"name":"bool"},"required":false,"description":"Establishes if image is with border","defaultValue":{"value":"false","computed":false}},"imageShadow":{"type":{"name":"bool"},"required":false,"description":"Establishes image with shadow","defaultValue":{"value":"false","computed":false}},"showFooter":{"type":{"name":"bool"},"required":false,"description":"Show or hide Card footer","defaultValue":{"value":"true","computed":false}},"buttonOutline":{"type":{"name":"bool"},"required":false,"description":"Establishes if <code>'See more'</code> button is outline","defaultValue":{"value":"true","computed":false}},"buttonColor":{"type":{"name":"string"},"required":false,"description":"Establishes color button","defaultValue":{"value":"'primary'","computed":false}},"featureBorder":{"type":{"name":"bool"},"required":false,"description":"Establishes if feature card has border","defaultValue":{"value":"false","computed":false}},"contentAlign":{"type":{"name":"string"},"required":false,"description":"Align of a component content. Can be <code>'left'</code>, <code>'center'</code> and <code>'right'</code>","defaultValue":{"value":"'center'","computed":false}},"columnClassName":{"type":{"name":"string"},"required":false,"description":"CSS class name for column","defaultValue":{"value":"'col-12 col-sm- col-md'","computed":false}},"features":{"type":{"name":"arrayOf","value":{"name":"shape","value":{"id":{"name":"union","value":[{"name":"string"},{"name":"number"}],"required":false},"image":{"name":"string","required":false},"title":{"name":"string","required":false},"subtitle":{"name":"string","required":false},"summary":{"name":"string","required":false},"link":{"name":"string","required":false},"linktext":{"name":"string","required":false}}}},"required":false,"description":"Array of features to show","defaultValue":{"value":"[]","computed":false}}},"filename":"/components/Features/Features.jsx"}

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _main = __webpack_require__(5);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _DetailsComponent = __webpack_require__(6);
	
	var _DetailsComponent2 = _interopRequireDefault(_DetailsComponent);
	
	var _features = __webpack_require__(506);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _map = __webpack_require__(1076);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ComponentView = function (_React$Component) {
	  _inherits(ComponentView, _React$Component);
	
	  function ComponentView() {
	    _classCallCheck(this, ComponentView);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ComponentView.prototype.render = function render() {
	    return _react2.default.createElement(
	      _main2.default,
	      { pagePushedFunction: this.handlepushedPageLayout },
	      _features2.default && _react2.default.createElement(_DetailsComponent2.default, {
	        name: _features2.default.name,
	        linkGithub: 'https://github.com/front10/landing-page-book/tree/master/src/components/Features',
	        description: _features2.default.summary,
	        stories: _features2.default.stories,
	        importCode: _features2.default.import,
	        withStyles: _features2.default.withStyles,
	        extractProps: _features2.default.extractProps,
	        propsDescription: _map2.default.props
	      })
	    );
	  };
	
	  return ComponentView;
	}(_react2.default.Component);
	
	exports.default = ComponentView;
	module.exports = exports['default'];

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var features = [{
	  image: 'https://front10.com/landing-page-book/images/features/speed.png',
	  title: 'Easy & Fast',
	  subtitle: 'Very easy and fast develop',
	  summary: 'Zero config, Online playground, Lots of examples.',
	  link: 'https://front10.com'
	}, {
	  image: 'https://front10.com/landing-page-book/images/features/themes.png',
	  title: 'Theming',
	  subtitle: 'Customize our components',
	  summary: 'Change the components colors, fonts, and look and feel in general using CSS variables.',
	  link: 'https://front10.com'
	}, {
	  image: 'https://front10.com/landing-page-book/images/features/integration.png',
	  title: 'Integration',
	  subtitle: 'Can be used in many plattaforms',
	  summary: 'Proven and painless integration with Create React App, GatsbyJS and NextJS.',
	  link: 'https://front10.com'
	}];
	
	exports.default = features;
	module.exports = exports['default'];

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _features = __webpack_require__(489);
	
	var _features2 = _interopRequireDefault(_features);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Features',
	  summary: 'Features are distinctive attribute or aspect of a product or service. Use it to highlight the most valuable pieces of your project, product or service.',
	  import: '',
	  extractProps: ['feature', 'featureSubTitle', 'featureSummary', 'button'],
	  stories: [{
	    name: 'Basic',
	    summary: '',
	    code: '<Features\n    buttonColor="primary"\n    features={' + JSON.stringify(_features2.default, null, 8) + '}\n/>',
	    tabsActive: ['code']
	  }, {
	    name: 'Image & title',
	    summary: '',
	    code: '<Features\n    showSubtitle={false}\n    showSummary={false}\n    showFooter={false}\n    features={' + JSON.stringify(_features2.default, null, 8) + '}\n/>',
	    tabsActive: []
	  }, {
	    name: 'With shadow',
	    summary: '',
	    code: '<Features\n    shadow\n    showSubtitle={false}\n    showFooter={false}\n    features={' + JSON.stringify(_features2.default, null, 8) + '}\n/>',
	    tabsActive: []
	  }, {
	    name: 'With image shadow',
	    summary: '',
	    code: '<Features\n      imageShadow\n      showSubtitle={false}\n      showFooter={false}\n      imageCircle={true}\n    features={' + JSON.stringify(_features2.default, null, 8) + '}\n/>',
	    tabsActive: []
	  }]
	};
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-components-features-js-73a491a779f2144c48e3.js